import TableContainer from "@material-ui/core/TableContainer";
import { MapContainer, TileLayer, ZoomControl } from "react-leaflet";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Accordion } from "react-bootstrap";
import Map from "../D3Layer";
import { useEffect, useState } from "react";
import axios from "axios";
import { token } from "../../config/index.js";
import { apiUrl } from "../../config/index.js";

export default function ResearcherGroup(props) {
  const { t } = useTranslation();
  const { concept_proposal_id } = props;
  const [mapData, setMapData] = useState([]);
  const [countResearcher, setCountResearcher] = useState("");
  const [countProject, setCountProject] = useState("");
  const [countAcademic, setCountAcademic] = useState("");
  const [countU2t, setCountU2t] = useState("");
  const localUrl = "http://localhost:4000";
  let id = concept_proposal_id;

  const mapDataTeam = async () => {
    const response = await axios.get(
      `${apiUrl}/api/get/us-project-map/team/${id}`,
      {
        headers: {
          "content-type": "application/json",
          "x-access-token": token.accesstoken,
        },
      }
    );

    setMapData(response.data);
    setCountResearcher(response.data.count_researcher);
    setCountAcademic(response.data.count_academic);
    setCountU2t(response.data.count_u2t);
    setCountProject(response.data.count_projects);
  };

  useEffect(() => {
    mapDataTeam();
  }, []);
  return (
    <TableContainer className="p-4">
      <Row>
        <Col sm={12}>
          <MapContainer
            className="minimap2sub1 "
            center={[15, 103]}
            zoom={7}
            scrollWheelZoom={true}
            zoomControl={false}
            style={{ zIndex: "0", borderRadius: "15px" }}
          >
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <ZoomControl position="topright" />
            {Object.keys(mapData).length > 0 ? (
              <Map location={mapData} />
            ) : null}
          </MapContainer>
        </Col>

        <Col sm={12}>
          <div
            className="dashboard"
            style={{ marginTop: "-4.5rem", marginBottom: "-1rem" }}
          >
            <div className="all-card">
              <Row style={{ paddingLeft: "10px" }}>
                <Col>
                  <div className="card">
                    <div className="card-body ">
                      <h5 className="card-title text-title">
                        {t("dashboard.research_network")}
                      </h5>
                      <h2 className="card-text text-amount">
                        {countResearcher} {t("dashboard.people")}
                      </h2>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="card">
                    <div className="card-body ">
                      <h5 className="card-title text-title">
                        {t("dashboard.research")}
                      </h5>
                      <h2 className="card-text text-amount">
                        {countProject} {t("dashboard.projects")}
                      </h2>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="card">
                    <div
                      className="card-body "
                      style={{ padding: "1rem 0.5rem" }}
                    >
                      <h5 className="card-title text-title">
                        {t("dashboard.academic")}
                      </h5>
                      <h2 className="card-text text-amount">
                        {countAcademic} {t("dashboard.projects")}
                      </h2>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="card">
                    <div className="card-body ">
                      <h5 className="card-title text-title">
                        {t("dashboard.u2t")}
                      </h5>
                      <h2 className="card-text text-amount">
                        {countU2t} {t("dashboard.projects")}
                      </h2>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </TableContainer>
  );
}





